import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminLogin } from "../../../slice/adminUser/adminUserSlice";
import { useNavigate } from "react-router-dom";
import LOGO from "../../../assets/logo.png"
export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { token, loading, error } = useSelector(
    (state) => state.adminUser
  );

  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  /* =========================
     REDIRECT AFTER LOGIN
  ========================= */
  useEffect(() => {
    if (token) {
    
      navigate("/admin/dashboard");
    }
  }, [token, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(adminLogin(form));
  };

  return (
    <div className="d-flex flex-column h-100 p-3 heighT">
      <div className="d-flex  flex-grow-1 justify-content-center align-items-center">
     
              <div className="col-lg-6 MAinBOX ">
                <div className="d-flex flex-column justify-content-center BOrder">
                  <div className="auth-logo mb-4">
                    <a className="logoPath">
                      <img
                        src={LOGO}
                        height={24}
                        alt="logo dark"
                        className="LOgoING"
                      />
                    </a>
               
                  </div>

                  <h2 className="fw-bold fs-24">Admin Sign In</h2>
                 

                  <div className="mb-5">
                    <form
                      className="authentication-form"
                      onSubmit={handleSubmit}
                    >
                      <div className="mb-3">
                        <label className="form-label">Username</label>
                        <input
                          type="text"
                          name="username"
                          placeholder="Username"
                          className="form-control"
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <input
                          type="password"
                          name="password"
                          placeholder="Password"
                          className="form-control"
                          onChange={handleChange}
                          required
                        />
                      </div>

                      {error && (
                        <p className="text-danger mt-2 text-center">
                          {error}
                        </p>
                      )}

                      <div className="mb-1 text-center d-grid">
                        <button
                          className="btn btn-soft-primary"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Logging in..." : "Login"}
                        </button>
                      </div>
                    </form>
                  </div>
            
         
          </div>

        </div>
      </div>
    </div>
  );
}
